export const appType = [
    {
        value:'1',
        label:'伯纳思网站'
    },
    {   
        value:"2",
        label:"旅当家网站"
    },
    {
        value:"3",
        label:"导当家公众号"
    },   
    {
        value:"4",
        label:"综点公众号"
    },   
]

export const appPayType = [
    {
        value:'1',
        label:'免费'
    },
    {   
        value:"2",
        label:"收费"
    },      
]